module.exports = __webpack_public_path__ + "static/media/parts.af02afe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/parts.png
// module id = 2439
// module chunks = 0